
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.625 2h-8.75C6.84 2 6 2.84 6 3.875v16.25C6 21.16 6.84 22 7.875 22h8.75c1.035 0 1.875-.84 1.875-1.875V3.875C18.5 2.84 17.66 2 16.625 2zM12.25 20.75c-.691 0-1.25-.558-1.25-1.25 0-.691.559-1.25 1.25-1.25s1.25.559 1.25 1.25c0 .692-.559 1.25-1.25 1.25zm4.375-4.219a.47.47 0 01-.469.47H8.344a.47.47 0 01-.469-.47V4.344a.47.47 0 01.469-.469h7.812a.47.47 0 01.469.469V16.53z","fill":"#282E3E"}})])
          )
        }
      }
    